'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "color", "hollow", "StatusDot", "use", "multiline"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';
import { SLINKY } from 'HubStyleTokens/colors';
import { TAG_HEIGHT } from 'HubStyleTokens/sizes';
import UITag from './UITag';
import { getComponentPropType } from '../utils/propTypes/componentProp';
import { FONT_FAMILIES, toPx } from '../utils/Styles';
import UIStatusDot from './UIStatusDot';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnenclosedTag = styled(UITag).withConfig({
  displayName: "UIStatusTag__UnenclosedTag",
  componentId: "gvh7fg-0"
})(["", " background-color:transparent;border-color:transparent;color:", ";line-height:normal;padding-left:0;vertical-align:middle;"], FONT_FAMILIES.default, SLINKY);
const Text = styled.span.withConfig({
  displayName: "UIStatusTag__Text",
  componentId: "gvh7fg-1"
})(["line-height:", ";"], toPx(parseInt(TAG_HEIGHT, 10) - 2));
const StatusFlexWrapper = styled.span.withConfig({
  displayName: "UIStatusTag__StatusFlexWrapper",
  componentId: "gvh7fg-2"
})(["margin-top:-4px;margin-bottom:-4px;"]);
export default function UIStatusTag(_ref) {
  let {
      children,
      className,
      color,
      hollow,
      StatusDot,
      use,
      multiline
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UnenclosedTag, Object.assign({
    use: use,
    multiline: children === undefined || multiline
  }, rest, {
    className: classNames('private-tag--unenclosed', className, hollow && 'private-tag--hollow'),
    _flexWrapperProps: {
      as: StatusFlexWrapper
    },
    children: /*#__PURE__*/_jsxs(Text, {
      className: "private-tag--unenclosed__text",
      children: [/*#__PURE__*/_jsx(StatusDot, {
        color: color,
        hollow: hollow,
        use: use
      }), children]
    })
  }));
}
UIStatusTag.propTypes = Object.assign({}, UITag.propTypes, {
  color: PropTypes.string,
  hollow: PropTypes.bool.isRequired,
  StatusDot: getComponentPropType(UIStatusDot).isRequired
});

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIStatusTag.defaultProps = Object.assign({}, UITag.defaultProps, {
  hollow: false,
  StatusDot: UIStatusDot,
  use: 'info'
});
UIStatusTag.displayName = 'UIStatusTag';